export const tabPermissionsTable = [
  {
    tab: "eventInfo",
    url: "/events/:eventId",
    queryParam: "show=eventInfo",
    actions: [],
    label: "Event Info",
  },
  {
    tab: "registrations",
    url: "/events/:eventId",
    queryParam: "show=registrations",
    actions: [],
    label: "Registrations",
  },
  {
    tab: "speakers",
    url: "/events/:eventId",
    queryParam: "show=speakers",
    actions: [],
    label: "Speakers",
  },
  {
    tab: "sponsors",
    url: "/events/:eventId",
    queryParam: "show=sponsors",
    actions: [],
    label: "Sponsors",
  },
  {
    tab: "exhibitors",
    url: "/events/:eventId",
    queryParam: "show=exhibitors",
    actions: [],
    label: "Exhibitors",
  },
  {
    tab: "stalls",
    url: "/events/:eventId",
    queryParam: "show=stalls",
    actions: [],
    label: "Stalls",
  },
  {
    tab: "oem",
    url: "/events/:eventId",
    queryParam: "show=oem",
    actions: [],
    label: "OEM",
  },
  // {
  //   tab: "createOem",
  //   url: "/events/:eventId/create-oem",
  //   queryParam: "",
  //   actions: [],
  //   actionsToHide: ["delete", "upload", "download"],
  // },
  {
    tab: "previewOem",
    url: "/events/:eventId/oem/view-form",
    queryParam: "",
    actions: [],
    label: "Preview OEM",
  },
  {
    tab: "schedule",
    url: "/events/:eventId",
    queryParam: "show=schedule",
    actions: [],
    label: "Schedule",
  },
  {
    tab: "analytics",
    url: "/events/:eventId",
    queryParam: "show=analytics",
    actions: [],
    label: "Analytics",
  },
  {
    tab: "emailMarketing",
    url: "/events/:eventId/communications/eventmarketing",
    queryParam: "",
    actions: [],
    label: "Email Marketing",
  },
  {
    tab: "linkedinMarketing",
    url: "/events/:eventId/communications/linkedin-marketing",
    queryParam: "",
    actions: [],
    label: "LinkedIn Marketing",
  },
  {
    tab: "whatsappMarketing",
    url: "/events/:eventId/communications/whatsapp-marketing",
    queryParam: "",
    actions: [],
    label: "WhatsApp Marketing",
  },
  {
    tab: "exhibitorDirectory",
    url: "/events/:eventId/communications/exhibitorDirectory",
    queryParam: "",
    actions: [],
    label: "Exhibitor Directory",
  },
  {
    tab: "emailNotifications",
    url: "/events/:eventId/communications/emailNotifications",
    queryParam: "",
    actions: [],
    label: "Notification Settings",
  },
  {
    tab: "mailChimp",
    url: "/events/:eventId/communications/mail-chimp",
    queryParam: "",
    actions: [],
    label: "Mail Chimp",
  },
  {
    tab: "whiteLabelEmailDomain",
    url: "/events/:eventId/communications/email-domain-whitelable",
    queryParam: "",
    actions: [],
    label: "White Label Email Domain",
  },
  {
    tab: "formBuilder",
    url: "/events/:eventId/settings/formbuilder",
    queryParam: "",
    actions: [],
    label: "Form Builder",
  },
  // {
  //   tab: "createFormBuilder",
  //   url: "/events/:eventId/settings/create-formbuilder",
  //   queryParam: "",
  //   actions: [],
  //   actionsToHide: ["delete", "upload", "download"],
  // },
  {
    tab: "ticketing",
    url: "/events/:eventId/settings/ticketing",
    queryParam: "",
    actions: [],
    label: "Ticketing",
  },
  {
    tab: "badgeTemplates",
    url: "/events/:eventId/settings/badge-templates",
    queryParam: "",
    actions: [],
    label: "Badge Templates",
  },
  {
    tab: "staffManagement",
    url: "/events/:eventId/settings/staff-management",
    queryParam: "",
    actions: [],
    label: "Staff Management",
  },
  {
    tab: "checkIn",
    url: "/events/:eventId/registrations",
    queryParam: "",
    actions: [],
    label: "Check In",
  },
  {
    tab: "extendedView",
    url: "/events/:eventId/registrations/extended-view",
    queryParam: "",
    actions: [],
    label: "Extended View",
  },
  {
    tab: "eventWhitelabeling",
    url: "/events/:eventId/settings/event-whitelabeling",
    queryParam: "",
    actions: [],
    label: "Event Whitelabeling",
  },
];
